import React from 'react';
import logo from '../assests/img/logo.png';
import Topmenuleft from './Topmenuleft';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { FaEnvelope, FaFacebook, FaHeadphones, FaPhone } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";
import { useState, useEffect } from "react";
import Mobilemenu from './Mobilemenu';
import { IoMdClose } from "react-icons/io";


function Header() {
  const [isDarkMode, setIsDarkMode] = useState(false);
  const location = useLocation();
  const isContactActive = location.pathname === '/contact';
  const closeMobileMenu = () => setIsDarkMode(false);

  useEffect(() => {
    if (isDarkMode) {
      document.body.classList.add("menu-open");
    } else {
      document.body.classList.remove("menu-open");
    }
  }, [isDarkMode]);


  return (
    <>
      <header>
        <div className='top-bar'>
            <div className='container'>
             <div className='row'>
                <div className='col-md-6'>
              <div className='top-contact'>
          <ul className='flex'>                  
                   

                            <li><FaPhone />  <a href="tel:+918006 2727 88">
                           +918006 2727 88
                          </a>
                          </li>
                          <li> <FaEnvelope/> <a href="mailto:thepicturevalley@gmail.com">
                           thepicturevalley@gmail.com
                          </a>
                          </li>
                </ul>

          </div>
          </div>
          <div className='col-md-6'>
              <div className='top-social'>

                <ul className='flex'>
                  <li> <a href="https://www.facebook.com/thepicturevalleyindia" target="_blank"><FaFacebook /></a></li>
                               <li>  <a href="#"><FaYoutube /></a></li>
                               <li>  <a href="https://www.instagram.com/thepicturevalleyagra?igsh=ZWc1c3Y0d3JkaXZo" target='_blank'><FaInstagram /></a></li>
                </ul>

            </div>
          </div>

        
           
        </div>
        </div>

        </div>
      
        
      <div className='container inner-header'>
       
        <div className='row'>
          <div className='col-md-2 upcoming-event-box'>
         

             <Link to='/home' className='logo-img-box'>
            <img className='main-logo' src={logo}/>           
            </Link>

              <button className='menu-toggle-btn' onClick={() => setIsDarkMode(true)}>
           <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 12L10 12" stroke="#212529" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M20 5L4 5" stroke="#212529" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M20 19L4 19" stroke="#212529" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
           </button>
         
             
                 
          </div>
          <div className='col-md-7 main-logo-box search-col'>
         

         

           <div className="header-element search-wrap">
              <Topmenuleft/>  
                                
                              </div>

          </div>


        
        </div>

       
      </div>


     

      

      <div className='mobile-menu'>
      <button className='menu-close-btn' onClick={closeMobileMenu}>
      <IoMdClose />
          </button>
        <Mobilemenu onClose={closeMobileMenu}/>
      </div>
    
      </header>
     
      </>
  )

}

export default Header;
